import React, { PureComponent } from 'react';
import { Button, Checkbox, Form, Icon, Modal } from 'semantic-ui-react';

export default class RequestDoctorInfoModal extends PureComponent {
  state = {
    isRequestDoctorCvChecked: false,
    isRequestDoctorSampleReportChecked: false,
  };

  onIsRequestDoctorCvCheckedChange = () => {
    this.setState(prevState => ({
      isRequestDoctorCvChecked: !prevState.isRequestDoctorCvChecked,
    }));
  };

  onIsRequestDoctorSampleReportCheckedChange = () => {
    this.setState(prevState => ({
      isRequestDoctorSampleReportChecked: !prevState.isRequestDoctorSampleReportChecked,
    }));
  };

  handleClose = () => {
    this.props.handleClose();
  };

  handleOk = () => {
    this.props.handleOk({
      doctorId: this.props.doctorId,
      isRequestDoctorCvChecked: this.state.isRequestDoctorCvChecked,
      isRequestDoctorSampleReportChecked: this.state
        .isRequestDoctorSampleReportChecked,
    });
  };

  render() {
    return (
      <Modal open={this.props.isOpen} size="small">
        <Modal.Header content="Request more doctor's information" />
        <Modal.Content>
          <Form.Field>
            <Checkbox
              label="CV"
              checked={this.state.isRequestDoctorCvChecked}
              onChange={this.onIsRequestDoctorCvCheckedChange}
            />
          </Form.Field>

          <Form.Field>
            <Checkbox
              label="Sample reports"
              checked={this.state.isRequestDoctorSampleReportChecked}
              onChange={this.onIsRequestDoctorSampleReportCheckedChange}
            />
          </Form.Field>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="green"
            onClick={this.handleOk}
            disabled={
              !this.state.isRequestDoctorCvChecked &&
              !this.state.isRequestDoctorSampleReportChecked
            }
          >
            <Icon name="paper plane" />
            <span>Send</span>
          </Button>
          <Button color="red" onClick={this.handleClose}>
            <Icon name="close" />
            <span>Close</span>
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
